import { RangeType } from "@/types/datePicker";
import { formatLocaleWithDash } from "@/utils/utils";

export const formatDateToString = (dateObj: Date, format: 'DD/MM/YYYY' | 'YYYY-MM-DD' = 'DD/MM/YYYY'): string | null => {
    if (!dateObj) return null;

    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    const year = dateObj.getFullYear();

    if (format === 'DD/MM/YYYY') {
        return `${day}/${month}/${year}`;
    } else if (format === 'YYYY-MM-DD') {
        return `${year}-${month}-${day}`;
    }

    return null; // In case of unsupported format
};

export const parseDateString = (dateString: string): Date | null => {
    if (!dateString) return null

    if (dateString.includes('/')) {
        const parts = dateString.split('/')
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Months are zero-based in JS Dates
        const year = parseInt(parts[2], 10);
        //use utc date
        return new Date(Date.UTC(year, month, day));
    } else {
        // If the format is ISO (YYYY-MM-DD)
        const parts = dateString.split('-')
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Months are zero-based in JS Dates
        const day = parseInt(parts[2], 10);
        return new Date(Date.UTC(year, month, day));
    }
};

export const formatDateRange = (locale: string ,date: Date | string | null): string => {
    if (typeof date === 'string') {``
        date = parseDateString(date);
    }
    if (!date) return "";
    const localeWithDash = formatLocaleWithDash(locale);
    return date.toLocaleDateString(localeWithDash, { day: '2-digit', month: 'short' });
}

export const getDiffrenceDatesInNight =(dates: RangeType): string => {
    if(!dates.start) return ""
    if(!dates.end) return ""
    // Parse the start and end dates from the provided string format (DD/MM/YYYY)
    const startDate = new Date(dates.start.split('/').reverse().join('/')); // Convert "DD/MM/YYYY" to "YYYY/MM/DD"
    const endDate = new Date(dates.end.split('/').reverse().join('/')); // Convert "DD/MM/YYYY" to "YYYY/MM/DD"

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = endDate.getTime() - startDate.getTime();

    // Convert milliseconds to nights (1 day = 24 hours = 86,400,000 milliseconds)
    const differenceInNights = differenceInMilliseconds / (1000 * 3600 * 24);

    // Return the difference as a string (rounded to the nearest whole number)
    return `${Math.round(differenceInNights)}`;
}